import Tab, { TabProps } from ".";
import Badge from "../Badge";
import styles from "./styles.module.css";

type TabWithBadgeProps<T extends string> = TabProps<T> & {
  badgeValue: string;
};

const TabWithBadge = <T extends string>({ badgeValue, ...restTabProps }: TabWithBadgeProps<T>) => {
  return (
    <Tab
      {...restTabProps}
      suffixComponent={
        <Badge variant="gray" type="weak" text={badgeValue} className={styles.badge} />
      }
    />
  );
};

TabWithBadge.displayName = "DS.Tab.WithBadge";

export default TabWithBadge;
